import { Eye, EyeOff } from "lucide-react";
import { useForumColors } from "@/context/ForumColorContext";
import { alpha } from "@/lib/forumColors";

/** Toggle forums in and out of view — a heavy week reads better one forum at a time. */
export const ForumFilter = () => {
  const { courts, colorMap, noForumColor, hidden, toggleForum, showAllForums } = useForumColors();

  const options = [
    ...courts.map((c) => ({ key: c.court_id, name: c.name, color: colorMap[c.court_id] })),
    { key: "no_forum", name: "No forum", color: noForumColor },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="forum-filter">
      <span className="label-caps mr-1">Forums</span>
      {options.map((o) => {
        const off = hidden.includes(o.key);
        return (
          <button
            key={o.key}
            data-testid={`forum-filter-${o.key}`}
            aria-pressed={!off}
            onClick={() => toggleForum(o.key)}
            title={off ? `Show ${o.name}` : `Hide ${o.name}`}
            className={`inline-flex items-center gap-2 pl-2.5 pr-3 py-2 rounded-sm border text-sm font-semibold transition-colors duration-200 ${
              off ? "border-border text-muted-foreground hover:bg-accent" : "hover:brightness-105"
            }`}
            style={
              off
                ? undefined
                : { borderColor: o.color, background: alpha(o.color, 0.14), color: o.color }
            }
          >
            <span
              className="h-3 w-3 rounded-full shrink-0"
              style={{
                background: off ? "transparent" : o.color,
                boxShadow: `inset 0 0 0 2px ${o.color}`,
              }}
            />
            <span className="max-w-[11rem] truncate">{o.name}</span>
            {off ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
          </button>
        );
      })}
      {hidden.length ? (
        <button
          data-testid="forum-filter-reset"
          onClick={showAllForums}
          className="px-3 py-2 rounded-sm border border-foreground text-sm font-semibold hover:bg-accent transition-colors duration-200"
        >
          Show all
        </button>
      ) : null}
    </div>
  );
};
